import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface DownloadCloudIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const DownloadCloudIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: DownloadCloudIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M12 14V20"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M15 19L12.7071 21.2929C12.3166 21.6834 11.6834 21.6834 11.2929 21.2929L9 19"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M19.9495 16C20.5978 15.3647 21 14.4793 21 13.5C21 11.567 19.433 10 17.5 10C17.3078 10 17.1192 10.0155 16.9354 10.0453C16.4698 6.63095 13.5422 4 10 4C6.13401 4 3 7.13401 3 11C3 12.9587 3.80447 14.7295 5.10102 16"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default DownloadCloudIcon
